import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useHouseholdIncomeChartsDataContext } from './hooks/useHouseholdIncomeChartsDataContext';

export const AverageFamilyIncome = () => {
    const { chartData } = useHouseholdIncomeChartsDataContext();

    return (
        <SimpleBars
            title={'Renda Familiar Média'}
            horizontal={false}
            subtitles={chartData?.averageFamilyIncome?.map((item) => item.description)}
            values={chartData?.averageFamilyIncome?.map((item) => item.total  ||  0)}
        />
    );
};
